import { mapGetters } from 'vuex';
import mvtListLinks from '@/common/components/mvtlistlinks/mvt-listlinks.vue';
import geoMapper from '../../../common/store/mapper/_geoMapper.js';

export default {
  name: 'schoolsTable',
  inject: ['$eventBus'],
  props: {
    data: {
        type: Array,
        default: []
    }
  },
  components: {
     mvtListLinks
  },
  computed: {
    ...mapGetters('glb', ['viewport', 'glb']),
    schoolsInfo(){
        let list=[];
        let hasDistance = false;
        list = this.data.map(item=>{
            let rating = parseInt(item.rating);
            let cls = '';
            const schoolGeo = geoMapper({city: (item.cityName || item.city), zipcode: (item.zipCode || item.zip), state: (item.stateCode || item.state)});
            const cityPath = schoolGeo.cityCode === 'dallas' && schoolGeo.stateCode === 'tx' ? 'dallas-tx/' : schoolGeo.cityPath;
            const schoolZoneUrl = this.glb.appUrl + cityPath + 'saz-' + (item.schoolId || item.uId) + '/';
            if (isNaN(rating) || rating === 0) {
                cls = 'null';
                rating = 'NR';
            } else if (rating <= 3) {
                cls = 'poor';
            } else if (rating <= 7) {
                cls = 'fair';
            } else {
                cls = 'good';
            }

            if (item.distance && item.distance != '-' && !hasDistance) {
                hasDistance = true;
            }
            return {
                ...item,
                rating,
                cls,
                schoolZoneUrl
            }
        });
        return { hasDistance, list };
    }
  }
};